function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { PageHeader } from "../../components/analytics-kit";
import StatusFilter from "../../components/status-filter";
import { ProductConfigurationsViewComponent } from "../product-configurations";
import PricingGrain from "./pricing";
import ProductsList from "./products-list";
import SeriesList from "./series-list";
import { rangeWithDates } from "./px-common";
import { cleanTitle, fetchSales, accountLensKv, readAcctLens, writeAcctLens, resolveBusinessModel } from "../sales/territory-common";
import { AccountFilterControl, AccountFilterBanner } from "../sales/account-filter";
import account from "../../data/account";
import { hasTenantFeature } from "../../functions/tenant-features";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * Products (the Product Explorer): one page, four tabs sharing the global
 * period, the order-type filter and the dealer (account) lens. Mockups:
 * productsflow/Main.dc.html (Products) + Series.dc.html (Series).
 *   • Products     → products-list.jsx (explorer endpoint, fail-soft fallback)
 *   • Series       → series-list.jsx (hidden per tenant by `noProductSeries`)
 *   • Options      → the Product Configurations page, embedded (query key: configs)
 *   • Demand gaps  → views/products/pricing.jsx (query key: pricing)
 * Query keys stay as before so ?grain= links keep working.
 */

const GRAINS = [{
  key: "products",
  label: "Products"
}, {
  key: "families",
  label: "Series"
}, {
  key: "configs",
  label: "Options"
}, {
  key: "pricing",
  label: "Demand gaps"
}];

// Series is opt-OUT per tenant (`noProductSeries`, e.g. Robb & Stucky: individual SKUs, no series).
function seriesHidden() {
  return hasTenantFeature("noProductSeries");
}
function visibleGrains() {
  return seriesHidden() ? GRAINS.filter(g => g.key !== "families") : GRAINS;
}
function grainFromSearch(search) {
  const m = /[?&]grain=([^&]+)/.exec(search || "");
  const g = m ? decodeURIComponent(m[1]) : "products";
  return GRAINS.some(x => x.key === g) ? g : "products";
}

// Product identity cell (36px thumbnail with a furniture-icon fallback, title over
// SKU). Used by Series detail and Demand gaps; kept here so those imports hold.
export function ProductCell({
  id,
  title,
  image,
  sku
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: "ws-prod"
  }, image ? /*#__PURE__*/React.createElement("img", {
    className: "ws-thumb",
    src: image,
    alt: "",
    loading: "lazy",
    onError: e => {
      e.target.style.display = "none";
    }
  }) : /*#__PURE__*/React.createElement("span", {
    className: "ws-thumb ws-thumb-empty",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons"
  }, "weekend")), /*#__PURE__*/React.createElement("span", {
    className: "ws-prod-txt"
  }, /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, cleanTitle(title) || id), /*#__PURE__*/React.createElement("span", {
    className: "code"
  }, sku || id)));
}
class ProductsWorkspaceComponent extends React.Component {
  constructor(props) {
    super(props);
    // Account lens: persisted per tenant. Empty = no-op.
    _defineProperty(this, "setAcctLens", (mode, ids) => {
      writeAcctLens((account.get() || {}).tenantId, mode, ids);
      this.setState({
        acctMode: mode,
        acctIds: ids,
        allRevenue: null
      }, () => this.loadAllRevenue());
    });
    _defineProperty(this, "removeAcct", id => this.setAcctLens(this.state.acctMode, this.state.acctIds.filter(x => String(x) !== String(id))));
    _defineProperty(this, "clearAcct", () => this.setAcctLens(this.state.acctMode, []));
    _defineProperty(this, "onStatus", v => this.setState({
      status: v || [],
      allRevenue: null
    }, () => this.loadAllRevenue()));
    _defineProperty(this, "setGrain", key => {
      if (key === this.state.grain) return;
      this.props.history.replace(`/Products/${this.range()}?grain=${key}`);
      this.setState({
        grain: key
      });
    });
    const lens = readAcctLens((account.get() || {}).tenantId);
    let initGrain = grainFromSearch(props.location && props.location.search);
    if (initGrain === "families" && seriesHidden()) initGrain = "products"; // deep link to a hidden tab → default
    this.state = {
      grain: initGrain,
      categories: null,
      status: [],
      comp: getGlobalComp("prev_year"),
      acctMode: lens.mode,
      acctIds: lens.ids,
      acctSource: [],
      businessModel: "manufacturing",
      allRevenue: null // Products-tab revenue, for the Series tab's "left out" note
    };
    this._alive = true;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  componentDidMount() {
    this.loadCategories();
    this.loadAcctSource();
    this.loadAllRevenue();
    resolveBusinessModel().then(m => {
      if (this._alive && m) this.setState({
        businessModel: m
      });
    }).catch(() => {});
    this._tok = subscribePeriod(({
      range,
      comp
    }) => {
      if (!this._alive) return;
      if (comp && comp !== this.state.comp) this.setState({
        comp
      });
      if (range) this.props.history.replace(`/Products/${range}?grain=${this.state.grain}`);
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
  }
  componentDidUpdate(prev) {
    const a = prev.params && prev.params.range || "";
    const b = this.props.params && this.props.params.range || "";
    if (a !== b) {
      this.setState({
        allRevenue: null
      }, () => {
        this.loadAllRevenue();
        this.loadAcctSource();
      });
    }
  }
  statusKey() {
    return (this.state.status || []).join(",");
  }
  acctKv() {
    return accountLensKv(this.state.acctMode, this.state.acctIds);
  }
  async loadAcctSource() {
    try {
      const rows = await fetchSales(`/sales/customers/${this.range()}?top=200`);
      if (this._alive) this.setState({
        acctSource: Array.isArray(rows) ? rows : []
      });
    } catch (e) {/* roster optional */}
  }
  async loadCategories() {
    try {
      const cats = await fetchSales(`/sales/product-categories?top=40`);
      if (this._alive) this.setState({
        categories: Array.isArray(cats) ? cats : []
      });
    } catch (e) {
      if (this._alive) this.setState({
        categories: []
      });
    }
  }
  // Revenue under the same filters for the Series tab's "left out" note: the Products tab's own
  // Revenue tile (explorer totals, the number that tab shows) and total sales (Dashboard/Sales).
  // The note used to call total sales "the Products tab" figure, but the Products tab leaves the
  // same non-series lines out, so its tile matched Series and the note's figure was nowhere on it.
  async loadAllRevenue() {
    const kv = [];
    if (this.statusKey()) kv.push(`status=${encodeURIComponent(this.statusKey())}`);
    if (this.acctKv()) kv.push(this.acctKv());
    const qs = kv.length ? "?" + kv.join("&") : "";
    const [t, ex] = await Promise.all([fetchSales(`/sales/totals/${this.range()}${qs}`).catch(() => null), fetchSales(`/sales/explorer/products/${this.range()}?${kv.concat(["top=1", "skip=0"]).join("&")}`).catch(() => null)]);
    if (!this._alive) return;
    const exRev = ex && ex.totals && ex.totals.revenue != null ? Number(ex.totals.revenue) : null;
    this.setState({
      allRevenue: {
        sales: Number(t && t.totalAmount) || null,
        products: exRev
      }
    });
  }
  renderGrain() {
    const {
      grain
    } = this.state;
    const range = this.range();
    const dealerWord = this.state.businessModel === "retail" ? "Customers" : "Dealers";
    const common = {
      range,
      statusKey: this.statusKey(),
      acctKv: this.acctKv(),
      comp: this.state.comp,
      history: this.props.history,
      dealerWord
    };
    if (grain === "families") return /*#__PURE__*/React.createElement(SeriesList, _extends({}, common, {
      productsRevenue: this.state.allRevenue
    }));
    if (grain === "products") return /*#__PURE__*/React.createElement(ProductsList, _extends({}, common, {
      categories: this.state.categories,
      seriesHidden: seriesHidden()
    }));
    if (grain === "pricing") return /*#__PURE__*/React.createElement(PricingGrain, {
      range: range,
      history: this.props.history
    });
    return /*#__PURE__*/React.createElement(ProductConfigurationsViewComponent, {
      key: range,
      embedded: true,
      params: {
        range
      }
    });
  }
  render() {
    const {
      grain
    } = this.state;
    const lensOn = this.state.acctIds && this.state.acctIds.length > 0;
    const filtersOn = lensOn || (this.state.status || []).length > 0;
    const sharedGrain = grain === "products" || grain === "families";
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view products-workspace wa-view px-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      title: "Products",
      subtitle: `What sells, what people look at, and what's coming next · ${rangeWithDates(this.range())}`,
      actions: this.state.businessModel === "retail" ? null : /*#__PURE__*/React.createElement("span", {
        className: "px-filters"
      }, /*#__PURE__*/React.createElement(StatusFilter, {
        range: this.range(),
        value: this.state.status,
        onChange: this.onStatus,
        width: 200
      }), /*#__PURE__*/React.createElement(AccountFilterControl, {
        customers: this.state.acctSource || [],
        mode: this.state.acctMode,
        ids: this.state.acctIds,
        onApply: this.setAcctLens
      }))
    }), lensOn && sharedGrain && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement(AccountFilterBanner, {
      customers: this.state.acctSource || [],
      mode: this.state.acctMode,
      ids: this.state.acctIds,
      onRemove: this.removeAcct,
      onClear: this.clearAcct
    })), filtersOn && !sharedGrain && /*#__PURE__*/React.createElement("div", {
      className: "wa-notice"
    }, "The order type and dealer filters apply to the Products and Series tabs. This tab shows every order."), /*#__PURE__*/React.createElement("nav", {
      className: "wa-switch px-tabs",
      "aria-label": "Products views"
    }, visibleGrains().map(g => /*#__PURE__*/React.createElement("a", {
      key: g.key,
      className: "wa-tab" + (g.key === grain ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: () => this.setGrain(g.key)
    }, g.label))), this.renderGrain());
  }
}
export default withRouter(ProductsWorkspaceComponent);